import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { BaseService } from '../../../../mesc/mesc.service';
import { AuthenticationService } from '../../../../../auth.service';
import { FilterableService } from '../../../../mesc/filterable-service';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent extends DataGridTemplate implements OnInit {
  private module: any = {};
  selectedTable: any;
  editForm: FormGroup;
  tables: FilterableService = new FilterableService();
  formDialog: FormDialogTemplate = new FormDialogTemplate();
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly service: BaseService,
    private readonly authService: AuthenticationService,
  ) { super(); }


  /**
   * 
   */
  ngOnInit() {
    this.editForm = this.formBuilder.group({ From: ['', Validators.required] });
    this.formDialog.initilize(new BehaviorSubject<string>('Select Date Range'), this.editForm, this.formControlTabs);
    this.formDialog.submitText = 'Submit';
    this.formDialog.save = this.onSave;
    this.controls.add = false;
    this.controls.edit = false;
    this.controls.delete = false;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Action' }];

    this.modal = true;
    this.controls.customToolBarButtons = [this.deleteControl]
    this.authService.getActiveModule()
      .subscribe(x => {
        if (x) {
          this.module = x;
          this.service.read(`common/AuditLog/GetAuditTables?moduleId=${this.module.Id}`)
            .then(x => {
              this.tables.next(x);
              const partTable = x[0];
              if (partTable) this.handleTableChange(partTable.Id);
            });
        }
      });
  }


  /**
   * 
   * @param opts 
   */
  read(opts: any): Promise<any> {
    return this.module && this.selectedTable ?
      this.service.read(`common/AuditLog/GetAuditLogs?moduleId=${this.module.Id}&table=${this.selectedTable}`)
        .then(data => data.map(x => {
          x.CreatedDate = new DatePipe('en-US')
            .transform(x.CreatedDate, 'short');
          return x;
        }))
      : Promise.resolve([]);
  }


  /**
   * 
   */
  handleTableChange = (dataItem) => {
    this.selectedTable = dataItem;
    this.refresh();
  };


  /**
   * 
   */
  handleDelete = () => {
    this.formDialog.next({});
  }


  /**
   * 
   * @param dataItem 
   * @param isNew 
   */
  save(dataItem: any, isNew: boolean): Promise<any> {
    const params: HttpParams = new HttpParams()
      .set('moduleId', this.module.Id)
      .set('table', this.selectedTable)
      .set('fromDate', new Date(dataItem.From).toISOString())
    return this.service.remove(`common/AuditLog?${params.toString()}`);
  }


  deleteControl = {
    iconClass: 'fa fa-fw fa-trash-o',
    text: 'Delete Audit Logs',
    title: 'Select a range to delete Audit Logs',
    primary: true,
    callback: this.handleDelete
  }

  formControls = [
    {
      type: 'date',
      name: 'From',
      title: 'Delete up until the following date:',
    },
  ]

  formControlTabs = [
    {
      selected: true,
      title: 'Date',
      formControls: this.formControls

    }
  ]

  columns: any[] = [
    {
      field: 'Action',
      title: 'Action',
      width: 140,
    },
    {
      field: 'Before',
      title: 'Before',
      template: {
        type: 'json'
      }
    },
    {
      field: 'After',
      title: 'After',
      template: {
        type: 'json'
      }
    },
    {
      field: 'Actor',
      title: 'Administrator',
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
    }
  ]


  /****************************************************************************
  * UNUSED
  ****************************************************************************/
  create(parentEditDataItem: any): void {
    return null;
  }
  edit(dataItem: any): void {
    return null;
  }
  delete(dataItem: any): Promise<any> {
    return Promise.resolve();
  }
}
